import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {repoAppBuilder} from '@github-ui/repo-app-builder'
import {FindingsRoutePath} from './route-paths'

export function buildPullRequestsFindingsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsFindingsRoute', {
    path: FindingsRoutePath,
    queries: [],
  })
}

export const pullRequestsFindingsRoute = buildPullRequestsFindingsRoute(repoAppBuilder)
